import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Form } from 'react-final-form';
import { connect } from 'react-redux';
import firebase from 'firebase/app';
import 'firebase/firestore';
import { watchAnswers } from '../actions';
import QuestionForm from './QuestionForm';
import { ANSWERS_COLLECTION } from '../constants';
import '../styles/Question.css';
import {
  getQuizID,
  getQuizSections,
  getQuestion,
  getQuizSectionIndex,
  getQuestionID,
  getQuestionNumber,
  getSectionName,
  getNextLinkTo,
  currentUserNumberQuestionsAnswered,
  totalNumberQuestions,
} from '../selectors';

class Question extends Component {
  static validate(values) {
    const errors = {};

    if (values.answer === '') {
      errors.answer = 'Invalid';
    }

    return errors;
  }

  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);

    this.state = {
      submitFailed: false,
    };
  }

  onSubmit(values) {
    const { userUID, questionID, dispatch } = this.props;

    return new Promise((resolve, reject) => firebase.firestore()
      .collection(ANSWERS_COLLECTION)
      .doc(userUID)
      .set(
        { [questionID]: (values.answer || null) },
        { merge: true },
      )
      .then(() => dispatch(watchAnswers()))
      .then((action) => {
        resolve()
      })
      .catch(() => {
        reject()
      }))
      .finally(() => {
        console.log('done')
        window.scrollTo(0, 0);
      });
  }

  render() {
    const { initialValues, lastOnline, lastOffline } = this.props;

    return (
      <div>
        <Form
          initialValues={initialValues}
          component={QuestionForm}
          validate={Question.validate}
          onSubmit={this.onSubmit}
          showOfflineMessage={lastOffline !== 0 && lastOnline !== 0 && (lastOffline > lastOnline)}
        />
      </div>
    );
  }
}

Question.propTypes = {
  lastOnline: PropTypes.number.isRequired,
  lastOffline: PropTypes.number.isRequired,
  userUID: PropTypes.string.isRequired,
  questionID: PropTypes.string.isRequired,
  question: PropTypes.shape({
    title: PropTypes.string.isRequired,
    answers: PropTypes.arrayOf(PropTypes.string).isRequired,
    correctAnswer: PropTypes.string.isRequired,
    successMessage: PropTypes.string.isRequired,
  }).isRequired,
  initialValues: PropTypes.shape({
    answer: PropTypes.string.isRequired,
  }).isRequired,
};


function mapStateToProps(state, ownProps) {
  return {
    lastOnline: state.lastOnline,
    lastOffline: state.lastOffline,
    questionID: getQuestionID(state, ownProps),
    question: getQuestion(state, ownProps),
    initialValues: {
      answer: '',
    },
    userUID: state.userUID,
    sectionIndex: getQuizSectionIndex(state, ownProps),
    quizID: getQuizID(state),
    quizSections: getQuizSections(state),
    questionNumber: getQuestionNumber(state, ownProps),
    sectionName: getSectionName(state, ownProps),
    nextLinkTo: getNextLinkTo(state, ownProps),
    numberOfQuestionsAnswered: currentUserNumberQuestionsAnswered(state, ownProps),
    totalNumberQuestions: totalNumberQuestions(state, ownProps),
  };
}

export default withRouter(connect(mapStateToProps)(Question));



// WEBPACK FOOTER //
// ./src/components/Question.js